const FILTER_BY_NAME = "FILTER_BY_NAME";
const FILTER_BY_SALE_PRICE = "FILTER_BY_SALE_PRICE";

export { FILTER_BY_NAME, FILTER_BY_SALE_PRICE };
